// extracted by mini-css-extract-plugin
module.exports = {"navLink":"AuthNav_navLink__AoBNP","activeNavLink":"AuthNav_activeNavLink__1Puki"};